import { Layout } from "../layout.interface";

/**
 * Function to  find props inside a layout tree, and execute a function on
 * each prop that was found
 */
export function deepTraverseProps(
  layout: Layout | undefined,
  iterator: (prop: any, key: string, allProps: { [key: string]: any }) => void
) {
  if (!layout) return;

  for (const item of layout) {
    if (!item) continue;
    for (const value of Object.values(item)) {
      if (Array.isArray(value)) {
        deepTraverseProps(value, iterator);
      } else if (typeof value === "object") {
        for (const [key, prop] of Object.entries(value)) {
          iterator(prop, key, value);
        }
      }
    }
  }
}
